




import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'

export const HADES_ICON_SIZE = {
  XSMALL: 'xs',
  SMALL: 'sm',
  BASE: 'base',
  LARGE: 'lg',
  XLARGE: 'xl',
}

export const HADES_ICON_FLIP = {
  HORIZONTAL: 'h',
  VERTICAL: 'v',
}

export const HADES_ICON_ROTATE = {
  0: '0',
  45: '45',
  90: '90',
  135: '135',
  180: '180',
  225: '225',
  270: '270',
  315: '315',
}

/**
 * 아이콘 컴포넌트 입니다. 태그나 객체등을 표현할때 사용합니다.
 *
 * https://materialdesignicons.com/
 */
@Component
export default class HdsIcon extends Vue {
  name = 'HdsIcon'

  /**
   * 아이콘의 이름을 지정합니다.
   */
  @Prop({
    type: String,
    default: 'home',
  })
  mdi!: string

  /**
   * 비활성 여부입니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: boolean

  /**
   * Primary 컬러셋을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  primary!: boolean

  /**
   * Secondary 컬러셋을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  secondary!: boolean

  /**
   * 크기를 선택합니다.
   */
  @Prop({
    type: String,
    default: HADES_ICON_SIZE.BASE,
    validator: function (value) {
      return Object.values(HADES_ICON_SIZE).indexOf(value) !== -1
    },
  })
  size!: string

  /**
   * 회전을 선택합니다.
   */
  @Prop({
    type: String,
    validator: function (value) {
      return Object.values(HADES_ICON_ROTATE).indexOf(value) !== -1
    },
  })
  rotate?: string

  /**
   * 뒤집기를 선택합니다. (v: vertical, h: horizontal)
   */
  @Prop({
    type: String,
    validator: function (value) {
      return Object.values(HADES_ICON_FLIP).indexOf(value) !== -1
    },
  })
  flip?: string

  /**
   * 회전 여부입니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  spin?: boolean

  /**
   * 색을 지정합니다.
   */
  @Prop({
    type: String,
  })
  color?: string

  get iconClasses() {
    return {
      mdi: true,
      'hds-icon': true,
      'hds-disabled': this.disabled,
      'hds-icon--primary': this.primary,
      'hds-icon--secondary': this.secondary,
      [`hds-size--${this.size}`]: true,
      [`mdi-${this.mdi}`]: true,
      [`mdi-rotate-${this.rotate}`]: !!this.rotate,
      [`mdi-flip-${this.flip}`]: !!this.flip,
      'mdi-spin': this.spin,
    }
  }

  get iconStyles() {
    return {
      color: this.color,
    }
  }
}
